import { GET_LIST_PRIZES,GET_PRIZES } from "./actions.type";
import { prizes } from "@/service/prizes";

function initState() {
  return {}
}

const state = initState();

const actions = {
  async [GET_LIST_PRIZES]({ }, data) {
    let response = await prizes.getListPrizes(data);
    // console.log(response);
    return response;
  },

  async [GET_PRIZES]() {
    const response = await prizes.spin();
    return response;
  },
};


const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};
